// extracted by mini-css-extract-plugin
export var card = "MobileCard-module--card--9ceab";
export var fadeInAnimation = "MobileCard-module--fadeInAnimation--5cbe8";
export var image = "MobileCard-module--image--c5b65";
export var link = "MobileCard-module--link--a6437";
export var picture = "MobileCard-module--picture--eda03";
export var title = "MobileCard-module--title--18507";